module.exports = __webpack_public_path__ + "static/media/secondareaproduct1.1058c502.jpg";